import { neverop } from 'utils/noop';
import { Suggestions, SearchBarContextType } from './types';

export const DefaultSearchBarContext: SearchBarContextType = {
    clearCtaLabel: '',
    hasFilterApplied: false,
    hasSuggestions: false,
    hasTextInputValue: false,
    inputRef: { current: null },
    inputValue: '',
    isModal: false,
    isSuggestionsOpen: false,
    isSearchBarDisabled: false,
    placeholder: '',
    predictiveInput: '',
    selectedSuggestionIndex: 0,
    suggestions: [] as Suggestions[],
    applySuggestion: neverop('SearchBarContext', 'applySuggestion'),
    closeSuggestions: neverop('SearchBarContext', 'closeSuggestions'),
    handleApplyTextSearch: neverop('SearchBarContext', 'handleApplyTextSearch'),
    handleClearCta: neverop('SearchBarContext', 'handleClearCta'),
    handleFocus: neverop('SearchBarContext', 'handleFocus'),
    handleKeyDown: neverop('SearchBarContext', 'handleKeyDown'),
    handleKeyPress: neverop('SearchBarContext', 'handleKeyPress'),
    onInputChange: neverop('SearchBarContext', 'onInputChange'),
    removeFilter: neverop('SearchBarContext', 'removeFilter'),
};

export default DefaultSearchBarContext;
